import React, { FC } from 'react';
import * as styles from './Logo.module.scss';
import LogoImage from '../../images/logo-name.svg';

const Logo: FC = () => {
  return (
    <div>
      <img className={styles.logo} src={LogoImage} alt="Cheuk Lee logo" />
    </div>
  );
};

export default Logo;